// extracted by mini-css-extract-plugin
module.exports = {"footerLinks":"A8hXA","footerLinkItem":"_1Rn-3","footerLink":"_3UCjG"};